import { CommandListBanners, type Banner } from "./commands/cmdListBanners";
import { CommandGetBanner } from "./commands/cmdGetBanner";
import { CommandCreateBanner, type BannerPayload } from "./commands/cmdCreateBanner";
import { CommandUpdateBanner } from "./commands/cmdUpdateBanner";
import { CommandTurnOffBanner } from "./commands/cmdTurnOffBanner";
import { CommandDeleteBanner } from "./commands/cmdDeleteBanner";
import { CommandGetCurrentBanner, type CurrentBanner } from "./commands/cmdGetCurrentBanner";

/** Admin > Banners (MPN-2171). Shared, because the Partner Dashboard reads it too (MPN-2266). */
export class BannerService {
  async listBanners(): Promise<Banner[]> {
    return new CommandListBanners().run();
  }

  async getBanner(uuid: string): Promise<Banner> {
    return new CommandGetBanner().run(uuid);
  }

  async createBanner(payload: BannerPayload): Promise<Banner> {
    return new CommandCreateBanner().run(payload);
  }

  async updateBanner(uuid: string, payload: Partial<BannerPayload>): Promise<Banner> {
    return new CommandUpdateBanner().run(uuid, payload);
  }

  async turnOffBanner(uuid: string): Promise<Banner> {
    return new CommandTurnOffBanner().run(uuid);
  }

  async deleteBanner(uuid: string): Promise<void> {
    return new CommandDeleteBanner().run(uuid);
  }

  /** The Live banner for the Partner Dashboard, or null. Any signed-in user may read it. */
  async getCurrentBanner(): Promise<CurrentBanner | null> {
    return new CommandGetCurrentBanner().run();
  }
}
